module.exports = __webpack_public_path__ + "53389fed6eca09b550ece0b34d9eb3ca.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/mug-mockup.png
// module id = 788
// module chunks = 0